import React, { forwardRef } from "react";
import { getDate, currentDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";

const InDsChiTietDongTien = forwardRef(
  ({ listData, totals, title, config, category, flow }, ref) => {
    const showHoaHong =
      (config?.HoaHongTraGop === "1" || config?.hoaHongTraGop === "1") &&
      (category === "TRAGOP" || category === "BHTG");

    const showGhiChu = ["QUYKHAC", "RUTQUY", "TRICHLAP"].includes(category);

    const showMaPhieu = [
      "CAMDO",
      "TINCHAP",
      "TRAGOP",
      "QUYKHAC",
      "TRICHLAP",
      "RUTQUY",
    ].includes(category);

    const showLoaiGD = category !== "TRICHLAP";

    const getKhachHangHeader = (cat) => {
      if (cat === "HUYDONG") return "Chủ nợ";
      if (cat === "NGUONVON") return "Cổ đông";
      if (cat === "TRICHLAP") return "Chi nhánh";
      return "Khách hàng";
    };

    const getMaPhieuHeader = (cat) => {
      return cat === "TRICHLAP" ? "Mã phiếu" : "Mã HĐ";
    };

    const getTienHeader = (cat, fl) => {
      if (cat === "TRICHLAP")
        return fl === "THU" ? "Thu trích lập" : "Chi trích lập";
      return fl === "THU" ? "Tiền thu" : "Tiền chi";
    };

    return (
      <div
        ref={ref}
        id="tblPrintChiTietDongTien"
        style={{ padding: "30px", width: "100%" }}
      >
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <h2
            style={{ margin: 0, textTransform: "uppercase", fontSize: "24px" }}
          >
            {title || "CHI TIẾT DÒNG TIỀN"}
          </h2>
          <p
            style={{
              margin: "5px 0 0 0",
              fontSize: "14px",
              fontStyle: "italic",
            }}
          >
            Ngày in: {currentDate()}
          </p>
        </div>

        <table
          border="1"
          className="table-bordered"
          style={{
            borderCollapse: "collapse",
            width: "100%",
            fontFamily: "Arial",
            fontSize: "13px",
            color: "#000",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
              <th
                style={{ width: "50px", textAlign: "center", padding: "5px" }}
              >
                STT <br />
                <span style={{ color: "red" }}>
                  [{totals?.TotalRecords || 0}]
                </span>
              </th>
              {showMaPhieu && (
                <th style={{ textAlign: "center", padding: "5px" }}>
                  {getMaPhieuHeader(category)}
                </th>
              )}
              {category === "TRICHLAP" && (
                <th style={{ textAlign: "center", padding: "5px" }}>Ngày</th>
              )}
              <th style={{ textAlign: "left", padding: "5px" }}>Nhân viên</th>
              <th style={{ textAlign: "left", padding: "5px" }}>
                {getKhachHangHeader(category)}
              </th>
              {category !== "TRICHLAP" && (
                <th style={{ textAlign: "center", padding: "5px" }}>Ngày GD</th>
              )}
              {showLoaiGD && (
                <th style={{ textAlign: "left", padding: "5px" }}>Loại GD</th>
              )}
              {showGhiChu && (
                <th style={{ textAlign: "left", padding: "5px" }}>Ghi chú</th>
              )}
              {showHoaHong && (
                <th style={{ textAlign: "right", padding: "5px" }}>
                  Hoa hồng <br />
                  <span style={{ color: "red" }}>
                    $={formatNumber(Math.abs(totals?.TotalPhiHoaHong || 0))}
                  </span>
                </th>
              )}
              <th
                style={{ textAlign: "right", width: "120px", padding: "5px" }}
              >
                {getTienHeader(category, flow)} <br />
                <span style={{ color: "red" }}>
                  $= {flow === "CHI" ? "\u2212" : ""}
                  {formatNumber(Math.abs(totals?.TotalSoTien || 0))}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {listData?.map((item, idx) => (
              <tr key={idx}>
                <td style={{ textAlign: "center", padding: "5px" }}>
                  {idx + 1}
                </td>
                {showMaPhieu && (
                  <td style={{ textAlign: "center", padding: "5px" }}>
                    {item.MaHopDong}
                  </td>
                )}
                {category === "TRICHLAP" && (
                  <td style={{ textAlign: "center", padding: "5px" }}>
                    {getDate(item.NgayGiaoDich)}
                  </td>
                )}
                <td style={{ padding: "5px" }}>{item.NhanVien}</td>
                <td style={{ padding: "5px" }}>{item.KhachHang}</td>
                {category !== "TRICHLAP" && (
                  <td style={{ textAlign: "center", padding: "5px" }}>
                    {getDate(item.NgayGiaoDich)}
                  </td>
                )}
                {showLoaiGD && (
                  <td style={{ padding: "5px" }}>{item.LoaiGiaoDich}</td>
                )}
                {showGhiChu && (
                  <td style={{ padding: "5px" }}>{item.GhiChu}</td>
                )}
                {showHoaHong && (
                  <td style={{ textAlign: "right", padding: "5px" }}>
                    {formatNumber(item.PhiHoaHong)}
                  </td>
                )}
                <td
                  style={{
                    textAlign: "right",
                    fontWeight: "bold",
                    padding: "5px",
                  }}
                >
                  {formatNumber(Math.abs(item.SoTien))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <style>
          {`
                    @media print {
                        @page { size: A4 portrait; margin: 10mm; }
                        #tblPrintChiTietDongTien .table-bordered th, 
                        #tblPrintChiTietDongTien .table-bordered td { 
                            border: 1px solid #000 !important; 
                            padding: 5px; 
                        }
                    }
                `}
        </style>
      </div>
    );
  },
);

export default InDsChiTietDongTien;
